// import CourseReviewCard from "./components/CourseReviewCard";
import { useEffect, useState } from "react";
import Data from "../../data/career_services.json";
import CareerServicesRequirementCard from "./components/CareerServicesRequirementCard";
import CareerServicesCurriculumLeftCard from "./components/CareerServicesCurriculumLeftCard";
import CareerServicesCurriculumRightCard from "./components/CareerServicesCurriculumRightCard";

function CareerServices() {
  const [width, setWidth] = useState(window.innerWidth);
  const [activeCurriculum, setActiveCurriculum] = useState(Data?.curriculum[0]);

  const handleClick = item => {
    console.log('onClick', item, activeCurriculum);
    
    if (width < 768 && item.id === activeCurriculum.id) {
      setActiveCurriculum({})
    } else {
      setActiveCurriculum(item)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);

      if (window.innerWidth > 768) {
        setActiveCurriculum(Data?.curriculum[0])
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

       
  return (
    <div className="container">
      <div className="row text-center mx-auto col-12">
      <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>
          100% Job Assurance with </b>
          <b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}>Logicmojo Full Stack Career Track</b>
        </h2>
        <div className="w-100 mt-md-2 mb-5 sub-title">
        We have designed a dedicated career track in full stack development, along with career support services, to help you become industry-ready and ensure you land your dream job!
        </div>
        {/* requirement */}
        <div className="row requirement">
          <div className="col-1 left d-flex flex-column align-items-center">
            <div className="circle-wrapper d-flex justify-content-center align-items-center">
              <span>1</span>
            </div>
            <div className="line-gradient"></div>
          </div>
          <div className="col-11 right">
            <div className="position-relative heading">
              <h3 className="text-left">Full Stack Developer Course Eligibility Criteria</h3>
              <img
                className="position-absolute"
                src="assets/images/sketch_line_heading.svg"
                alt=""
              />
            </div>
            <div className="row">
              {Data.requirement.map((item) => (
                <CareerServicesRequirementCard {...item} />
              ))}
            </div>
          </div>
        </div>
        {/* -/- requirement */}
        {/* Curriculum */}
        {/*
        <div className="row curriculum">
          <div className="col-1 left d-flex flex-column align-items-center">
            <div className="circle-wrapper d-flex justify-content-center align-items-center">
              <span>2</span>
            </div>
            <div className="line-gradient"></div>
          </div>
          <div className="col-11 right">
            <div className="position-relative heading">
              <h3 className="text-left">Placement Assistance Program</h3>
              <img
                className="position-absolute"
                src="assets/images/sketch_line_heading.svg"
                alt=""
              />
            </div>
            <div className="row">
              <div className="col-md-6 inner-left">
                {Data?.curriculum.map((item) => (
                  <CareerServicesCurriculumLeftCard handleClick={handleClick} {...item} width={width} activeCurriculum={activeCurriculum} />
                ))}
              </div>
              <div className={`col-md-6 inner-right ${width < 768 ? 'd-none' : ''}`}>
                <CareerServicesCurriculumRightCard {...activeCurriculum?.topices} />
              </div>
            </div>
            <div className="meta-section d-flex flex-column align-items-center">
              <a target ="_default" href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-09">Explore Program</a>
            </div>
          </div>
        </div>
        */}
        {/* -/- Curriculum */}
        {/* services */}
        
        <div className="row services">
          <div className="col-1 left d-flex flex-column align-items-center">
            <div className="circle-wrapper d-flex justify-content-center align-items-center">
              <span>2</span>
            </div>
            <div className="line-gradient"></div>
          </div>
          <div className="col-11 right">
            <div className="position-relative heading">
              <h3 className="text-left">Logicmojo Career Services</h3>
              <img
                className="position-absolute"
                src="assets/images/sketch_line_heading.svg"
                alt=""
              />
            </div>
            <div className="row">
              {Data.services.map((item) => (
                <CareerServicesRequirementCard {...item} />
              ))}
            </div>
          </div>
        </div>
        {/* -/- services */}
        {/* requirement */}
        <div className="row companies">
          <div className="col-1 left d-flex flex-column align-items-center">
            <div className="circle-wrapper d-flex justify-content-center align-items-center">
              <span>3</span>
            </div>
            <div className="line-gradient"></div>
            <div className="end-point"></div>
          </div>
          <div className="col-11 right">
            <div className="position-relative heading">
              <h3 className="text-left">
                Land your dream job at one of the leading tech companies
              </h3>
              <img
                className="position-absolute"
                src="assets/images/sketch_line_heading.svg"
                alt=""
              />
            </div>
            <div className="row companies-wrapper">
              {Data.companies.map((item, index) => {
                return (
                  <div className="col-4">
                    <picture>
                      <img src={item} alt={`company-${index}`} width={100} />
                    </picture>
                  </div>
                );
              })}
            </div>
            <div className="meta-section d-flex flex-column align-items-center">
              <p>Book a call with our Senior Full Stack Engineer</p>
              <a target ="_default" href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-09">Explore Program</a>
            </div>
          </div>
        </div>
        {/* -/- requirement */}
      </div>
    </div>
  );
}
export default CareerServices;
